import store from "../index.js";
import { getPanelToken } from "./AuthActions";

export function getSessionInfo(){
    return parseToken(store.getState().auth.session);
}
export function hasAccessToPanel(panel){
    return  store.dispatch(getPanelToken()).then(()=>{
        let tk = parseToken(store.getState().auth.claims);
        return tk.valid && tk.claims.panels.indexOf(panel)!= -1;
    });
    
}

export function isTokenValid(key){
    return parseToken(store.getState().auth[key]).valid;
}

/**
 * @param {string} tk JWT token 
 * @return {{valid: boolean, claims: Object }} description
 */
export function parseToken(tk){
    if(tk == null){ return { valid: false } }
    let now = Math.floor(Date.now()/1000);
    let tkPart = tk.split(".")[1];
    if(tkPart == null){return { valid: false };}
    let claims = JSON.parse(atob(tkPart));

    // console.warn(tkPart, {
    //     iss: claims.iss == "zetaremote.api",
    //     exp: claims.exp > now,
    //     expValue: claims.exp,
    //     now
    // })
    
    return {
        valid: (claims.iss == "zetaremote.api" && claims.exp > now),
        claims: claims
    };
}

export const isSessionValid = isTokenValid.bind(null, "session");
export const isClaimsValid = isTokenValid.bind(null, "claims");